<template>
  <v-card>
    <v-card-title>Preview corpo email:</v-card-title>
    <iframe
      id="preview"
      sandbox="allow-popups"
      frameborder="0"
      width="100%"
      height="600"
      :srcdoc="html"
    />
  </v-card>
</template>

<script>
export default {
  name: 'PreviewCodeModal',
  props: {
    html: {
      type: String,
      default() {
        return '';
      },
    },
  },
};
</script>
